const type = 'consumable';
const platform = 'ios-appstore';
export const productTemplate = [
    'consumable.topup.199',
    'consumable.topup.450',
    'consumable.topup.700',
    'consumable.topup.900',
    'consumable.buy.history.2years',
    'consumable.firmware.h2000plus',
    'consumable.tariff.pro',
].map((id) => ({ id, type, platform }));
